import { NotificationsPreferenceResultAjax } from './notifications-preferences.backend-model';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    notificationsPreferences: NotificationsPreferenceResultAjax;
  }
}

export const notificationsPreferencesBackend = {
  fetch: () => ({
    endpoint: `notifications/preferences.php`,
    isGaf: true,
    params: {},
  }),
  post: () => ({
    endpoint: `notifications/preferences.php`,
    isGaf: true,
    params: {},
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/notifications-preferences/notifications-preferences.backend.ts